import c from "react";
import { cls as g } from "../../helpers/cls.js";
import { spacingReplace as a } from "../../helpers/spacingReplace.js";
var O = Object.defineProperty,
  n = Object.getOwnPropertySymbols,
  o = Object.prototype.hasOwnProperty,
  l = Object.prototype.propertyIsEnumerable,
  m = (r, e, i) => e in r ? O(r, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: i
  }) : r[e] = i,
  x = (r, e) => {
    for (var i in e || (e = {})) o.call(e, i) && m(r, i, e[i]);
    if (n) for (var i of n(e)) l.call(e, i) && m(r, i, e[i]);
    return r;
  },
  b = (r, e) => {
    var i = {};
    for (var t in r) o.call(r, t) && e.indexOf(t) < 0 && (i[t] = r[t]);
    if (r != null && n) for (var t of n(r)) e.indexOf(t) < 0 && l.call(r, t) && (i[t] = r[t]);
    return i;
  };
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const s = r => {
  var e = r,
    {
      inverted: i,
      margin: t,
      marginLeft: d,
      marginBottom: f,
      marginTop: p,
      marginRight: v
    } = e,
    _ = b(e, ["inverted", "margin", "marginLeft", "marginBottom", "marginTop", "marginRight"]);
  return c.createElement("hr", x({
    className: g("olx-divider", i && "olx-divider--inverted", a("olx-m", t), a("olx-ml", d), a("olx-mb", f), a("olx-mt", p), a("olx-mr", v)),
    "data-ds-component": "DS-Divider"
  }, _));
};
export { s as Divider };